// extracted by mini-css-extract-plugin
export default {"filterButton":"styles_filterButton__KPbii","buttonText":"styles_buttonText__uY856","ordinal":"styles_ordinal__tnP9F","ordinalSmall":"styles_ordinalSmall__0rT48"};